Vue.component('cards', {
  template: templates.cards,
  data() {
    return {
      model: {
        edit: false,
        card: {
          name: null,
          hp: 0,
          attack: 0,
          defence: 0,
          accuracy: 0,
          speed: 0,
          type: null,
          ability: null,
          ultimate: 0,
          active: false
        },
        cards: {
          
        },
        types: {
          
        },
        tiers: {
          '1': {
            name: 'Standard'
          },
          '2': {
            name: 'Ultra'
          },
          '3': {
            name: 'Legendary'
          }
        },
        abilities: {
          
        }
      }
    }
  },
  mounted() {
    const c = this;
    c.$root.$on('types', types => {
      c.model.types = types;
    });
    c.$root.$on('abilities', abilities => {
      c.model.abilities = abilities;
    });
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      cardService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.image = `/images/cards/${d.id}.png`;
            data[`${d.id}`] = d;
          }
          c.model.cards = data;
          c.$root.$emit('unlockCards', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.cards[`${id}`];

      if (id == c.model.card.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.card = {
        id: id,
        name: data.name,
        hp: data.hp,
        attack: data.attack,
        defence: data.defence,
        accuracy: data.accuracy,
        speed: data.speed,
        type: data.type,
        ability: data.ability,
        ultimate: data.ultimate,
        active: data.active
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;
      const data = c.model.card;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (data.active && (data.hp == 0 || data.attack == 0 || data.defence == 0 || data.accuracy == 0 || data.speed == 0)) {
        utils.alert.error('HP, Attach, Defence, Speed and Accuracy are required to activate a card.');
        return;
      }
      
      cardService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.cards[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.cards[`${data.id}`] = data;
          }

          c.reset();

          utils.alert.success('Saved!');
          
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    upload() {
      const c = this;

      let data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      data.append('type', 'cards');
      data.append('id', c.model.card.id);

      uploadService.uploadFile(data)
        .then(function (response) {
          utils.alert.success('File uploaded!');
        })
        .catch(function (error) {
          utils.alert.error('File failed to uploaded.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;

      c.model.card = {
        name: null,
        hp: 0,
        attack: 0,
        defence: 0,
        accuracy: 0,
        speed: 0,
        type: null,
        ability: null,
        ultimate: 0,
        active: false
      }
    }
  }
});